import { Component, ojs, app } from "modular-openscriptjs";

const router = app("router");
const h = app("h");

export default class Link extends Component {
	goto(link = "/") {
		router.to(link);
		return;
	}

	render(type, text, path, ...args) {
		return h[type](
			{
				onclick: this.method("goto", path),
			},
			text,
			...args
		);
	}
}
